import axios from "axios";
import apiConfig, { bookingAPIKey } from "../../service/apiConfig";
import { useFormConfigContext } from "../contexts/FormConfigContext";
import { useFormContext } from "../contexts/FormContext";
import useImageUpload from "./useImageUpload";

interface PostQuotePayload {
  conceptID: number;
  vendorID: string;
  customerNumber: number;
  status: string;
  progDefIds: number[];
  size: number;
}

const usePostQuote = () => {
  const { formValues } = useFormContext();
  const { formConfig } = useFormConfigContext();
  const { handleUpload } = useImageUpload();

  const buildPayload = (): PostQuotePayload => {
    const progDefIds = formValues?.selectedServiceDetails?.map((service) =>
      Number(service.externalId),
    ) ?? [52];

    return {
      conceptID: Number(formConfig.conceptid),
      vendorID: formConfig.vendorId,
      customerNumber: Number(formValues.customerNumber),
      status: formValues?.status ?? "1",
      progDefIds: progDefIds,
      size: formValues?.["estimate-lawn-size"] / 1000,
    };
  };

  const postQuote = async () => {
    try {
      await handleUpload();
      const payload = buildPayload();
      const response = await axios.post(
        apiConfig?.postQuote ?? "/public/quote",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            apiKey: bookingAPIKey[process.env.NODE_ENV || "development"],
          },
        },
      );
      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        return { error: true, message: "Failed to post quote" };
      }
    } catch (error: any) {
      console.error("Error posting quote:", error);
      return {
        error: true,
        message: error?.response?.data?.detail || "Network error",
      };
    }
  };

  return { postQuote };
};

export default usePostQuote;
